import React from "react";
import { Descriptions, Typography } from "antd";
import { useSelector } from "react-redux";

const { Text } = Typography;

function BankTopUp() {
  const { walletObj } = useSelector((state) => state.obj);

  const accountDetails = [
    {
      key: "1",
      label: "Bank Name",
      children: <Text>Diamond Trust Bank (DTB)</Text>,
    },
    {
      key: "2",
      label: "Account Number",
      children: <Text>0290657001</Text>,
    },
    {
      key: "3",
      label: "Account Name",
      children: <Text>NDOVUPAY LIMITED</Text>,
    },
    {
      key: "4",
      label: "Wallet Code",
      children: <Text>{walletObj?.walCode || "N/A"}</Text>,
    },
  ];

  const paymentSteps = [
    {
      key: "branch",
      title: "Option 1: DTB Bank Branch",
      steps: [
        "Visit any DTB branch near you",
        "Fill in a deposit slip with the following details:",
        "In the reference/narration field, enter your Wallet Code",
        "Hand over the deposit slip and cash to the teller",
        "Collect your deposit receipt and keep it safe",
      ],
      subDetails: ["Account Number: 0290657001", "Amount to deposit"],
    },
  ];

  return (
    <div className="flex flex-col w-full">
      <div className="mt-[1.25rem] w-full">
        <div className="!text-[#0E0E0E] !font-[500] !mb-[1rem]">
          Bank Deposit Instructions
        </div>

        <div className="text-[#0E0E0E] text-[1rem] font-[500] mb-[.5rem]">
          How to Pay via DTB (Diamond Trust Bank)
        </div>

        <div className="mt-[1rem] rounded-[.25rem] border border-dashed border-[#C8D3E0] p-[1rem] bg-transparent">
          <div className="text-[#0E0E0E] text-[.875rem] font-[500] mb-[.5rem]">
            Account Details
          </div>
          <Descriptions
            column={1}
            colon={true}
            items={accountDetails}
            labelStyle={{ color: "#424242", fontWeight: 400 }}
            contentStyle={{ color: "#0E0E0E" }}
          />
        </div>

        <div className="mt-[1.5rem]">
          <div className="text-[#0E0E0E] text-[.875rem] font-[500] mb-[.75rem]">
            Payment Steps
          </div>

          {paymentSteps?.map((option) => (
            <div key={option?.key} className="mb-[1rem]">
              <div className="text-[#0E0E0E] text-[.875rem] font-[500] mb-[.5rem]">
                {option?.title}
              </div>
              <ol className="list-decimal pl-[1.25rem] text-[#424242] text-[.875rem]">
                {option?.steps.map((step, index) => (
                  <li key={index} className="mb-[.5rem]">
                    {step}
                    {index === 1 && option?.subDetails && (
                      <ul className="list-disc pl-[1rem] mt-[.25rem]">
                        {option?.subDetails?.map((detail, detailIndex) => (
                          <li key={detailIndex} className="text-[#424242]">
                            {detail}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BankTopUp;
